var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-tooltip',{attrs:{"placement":_vm.position}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.content)+" ")]),_c('a-button',{staticClass:"tooltip-button"},[_vm._t("default",function(){return [_c('img',{staticClass:"info-icon",attrs:{"src":"img/icons/info.svg"}})]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }